import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = { class: "bi-tmpl-detail__right__cmpt__title" }
const _hoisted_3 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  style: {"height":"120px","display":"flex","align-items":"center"}
}

import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import PcModuleManSex from '../../../../../bi-pc-module/pc-module-age-man/index';
import { commonSVG } from '../../../commonSVG';

const CHILD_KEY = '4_2_3';

export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-4-2-3',
  setup(__props) {

const TYPE_MAPPING: Array<{
  value: any;
  moduleType?: any;
  index: number;
  svg?: string;
}> = [
  ...[1, 2, 3, 4, 5, 6].map(i => {
    return {
      value: 'pc-module-age-distribution-' + i,
      moduleType: 'pc-module-age-man-' + i,
      index: i
    };
  }),
  {
    svg: commonSVG,
    value: [2, 3, 9, 6, 10, 7].join(','),
    index: 6
  }
];

const cmpName = name => {
  return PcModuleManSex.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(curItem).title), 1),
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 200,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TYPE_MAPPING, (item, index) => {
          return _createElementVNode("div", {
            style: {"height":"200px","width":"100%"},
            key: index,
            onClick: ($event: any) => (_unref(onChange)(item.value))
          }, [
            _createVNode(_unref(BaseCard), { style: {"width":"420px","height":"200px"} }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseRadio), {
                  class: "bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w",
                  value: item.value,
                  "model-value": _unref(curItem).value
                }, {
                  default: _withCtx(() => [
                    (item.svg)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          innerHTML: item.svg,
                          style: {"margin-top":"24px"}
                        }, null, 8, _hoisted_5))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.moduleType))))
                        ]))
                  ]),
                  _: 2
                }, 1032, ["value", "model-value"])
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_4)
        }), 64))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})